import {useEffect} from 'react';

import {getAssetUrl} from 'coreUtils/adapters/sdk';

import {IMarkerWrapperProps} from './IMarker';

const Marker = ({map, position, store, clickCallback}: IMarkerWrapperProps) => {
	useEffect(() => {
		const google = window.google;

		if (!google?.maps?.Marker || !map) {
			return;
		}

		/**
		 * TODO: Replace with AdvancedMarkerElement
		 * Marker are deprecated but not discontinued. We don't need the new features.
		 * Forcing script reload without full page reload AdvancedMarkerElement causes an Illegal Constructor error.
		 */
		const marker = new google.maps.Marker({
			map,
			position,
			icon: getAssetUrl(`static/img/store_locator/marker-casadei.png`),
		});

		if (clickCallback) {
			marker.addListener('click', () => clickCallback({store, marker}));
		}

		if (!marker) {
			return;
		}

		return () => {
			marker.setMap(null);
		};
	}, [map, window.google]);

	return false;
};

export default Marker;
